export default __webpack_public_path__ + "static/media/FSKoopman-Medium.590624dc.woff2";